'use client'

import {
  CURRENT_SUBSIDIARY,
  CONSUMER_WEB_PLATFORM,
  SUBSIDIARY_CONFIG,
} from '@/utils/constants'
import { Phone } from 'lucide-react'

import { eventConstants, trackEvent } from '@/utils/events'
import { loadState } from '@/utils/localStorage'
import { useSelector } from '@/lib/store'
import Link from 'next/link'
const loggedInMobileNumber = loadState('ctxVal') || null
const ContactOnCall = ({ page = 'HOME' }) => {
  const cityState = useSelector((state) => state.city)
  const { CUSTOMER_CARE_DISPLAY_NUMBER, CUSTOMER_CARE_NUMBER_WITH_TEL } =
    SUBSIDIARY_CONFIG

  const handleRedirect = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

     const eventPayload = {
       u_mb: loggedInMobileNumber || '',
       city: cityState?.currentCityObj?.name || null,
       app: CONSUMER_WEB_PLATFORM,
       subsidiary: CURRENT_SUBSIDIARY,
     }
    trackEvent(eventConstants.CALL_CUSTOMER_CARE,eventPayload)

    setTimeout(() => {
      window.location.href = CUSTOMER_CARE_NUMBER_WITH_TEL
    }, 300)
  }

  return (
    <div
      className={`bg-primary-50 w-fit rounded-full flex items-center fixed right-6  z-10 contact_call_wrapper ${
        page === 'HOME' ? 'bottom-40' : 'bottom-20'
      }`}
    >
      <div className="bg-primary-500 w-14 h-14 rounded-full flex items-center justify-center">
        <Link
          href={CUSTOMER_CARE_NUMBER_WITH_TEL}
          target="_self"
          className={`text-label-sm font-semibold`}
          onClick={(e) => handleRedirect(e)}
        >
          <Phone size={24} className="text-white-100" />
        </Link>
      </div>
      <div className="py-[0.375rem] contact_call_content">
        <p className="text-label-md text-primary-500">Call us to book test</p>
        <Link
          href={CUSTOMER_CARE_NUMBER_WITH_TEL}
          target="_self"
          className="text-label-md"
          onClick={(e) => handleRedirect(e)}
        >
          {CUSTOMER_CARE_DISPLAY_NUMBER}
        </Link>
      </div>
    </div>
  )
}

export default ContactOnCall
